export const receiveChannels = 'CHANNEL/receiveChannels';
export const receiveCreateChannel = 'CHANNEL/receiveCreateChannel';
export const receiveUpdateChannel = 'CHANNEL/receiveUpdateChannel';
export const removeChannel = 'CHANNEL/removeChannel';
export const requestData = 'CHANNEL/requestData';
export const receiveBandwidthSearch = 'CHANNEL/receiveBandwidthSearch';
export const requestSearchData = 'CHANNEL/requestSearchData';
export const setClearedBandwidthNumbers = 'CHANNEL/setClearedBandwidthNumbers';
export const receiveChannelView = 'CHANNEL/receiveChannelView';
